import React from "react";
import SectionDivider from "./../widgets/SectionDivider";
import { widgetMap } from "../engine/widgetMap";
import { QuestionInstructionAudioContext } from "../widgets/QuestionLayout";

function WidgetRenderer({
  question,
  value,
  onChange,
  mode,
  feedback
}) {
  if (question.type === "section-divider") {
    return <SectionDivider label={question.config.label} />;
  }

  const Widget = widgetMap[question.type];

  return (
    <QuestionInstructionAudioContext.Provider
      value={question.config?.instructionAudio ?? null}
    >
      <Widget
        id={question.id}
        config={question.config}
        value={value}
        onChange={onChange}
        mode={mode}
        feedback={feedback}
      />
    </QuestionInstructionAudioContext.Provider>
  );
}

export default React.memo(WidgetRenderer);
